import { create } from "zustand";
import type { EquipmentType } from "../types";

interface EquipmentTypesState {
	modalOpen: boolean;
	editingItem: EquipmentType | null;
}

interface EquipmentTypesActions {
	openCreateModal: () => void;
	openEditModal: (item: EquipmentType) => void;
	onOpen: (item?: EquipmentType) => void;
	closeModal: () => void;
}

type EquipmentTypesStore = EquipmentTypesState & EquipmentTypesActions;

export const useEquipmentTypesStore = create<EquipmentTypesStore>((set) => ({
	modalOpen: false,
	editingItem: null,

	openCreateModal: () => {
		set({ modalOpen: true, editingItem: null });
	},

	openEditModal: (item) => {
		set({ modalOpen: true, editingItem: item });
	},

	onOpen: (item) => {
		set({ modalOpen: true, editingItem: item ?? null });
	},

	closeModal: () => {
		set({ modalOpen: false, editingItem: null });
	},
}));
